export enum EmailStatus {
  UNSENT = "UNSENT",
  SENT = "SENT",
  DELIVERED = "DELIVERED",
  SENDING_FAILED = "SENDING_FAILED",
  DELIVERY_FAILED = "DELIVERY_FAILED",
}
